import '../scss/main.scss';


import { followMenu } from './modules/followMenu';


import { hamburger } from './components/hamburger';
import { clouds} from './components/clouds';
import { carousels } from './components/carousels';
import { map } from './components/map';
import { lenis } from './components/lenis';
import { bird } from './components/bird';
import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
document.addEventListener("DOMContentLoaded", () => {
    carousels();
    followMenu();
    hamburger();
    clouds();
    map();
    lenis();
    bird();
    let acc = document.querySelector(".accordion-container");
    if(acc) {
        new Accordion('.accordion-container');

    }
})
